import React from "react";
import { Dropdown } from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Link } from "react-router-dom";

function EmployeeId({ employeeId, id, form }) {
  return (
    <div className="d-flex mr-3">
      {employeeId && (
        <>
          <h5 className="font-weight-bold">Employee ID: </h5>
          <h5 className="mx-2">{employeeId}</h5>
        </>
      )}

      <Dropdown className="col-1 dropdownBtn threeDot" style={{ marginTop: "-3px" }}>
        <Dropdown.Toggle id="dropdown-basic">
          <BsThreeDotsVertical size={18} />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {form?.employmentStatus === "active" ? (
            <>
              {" "}
              <Link to={`/user-management/employee/edit/` + id}>
                <Dropdown.Item href="javascript:void(0)">
                  Edit Basic Details
                </Dropdown.Item>
              </Link>
              <Link to={`/user-management/employee/location/` + id}>
                <Dropdown.Item href="javascript:void(0)">Edit location</Dropdown.Item>
              </Link>
              {form?.siteType === 3 && (
                <>
                  <Link to={`/user-management/employee/training/` + id}>
                    <Dropdown.Item href="javascript:void(0)">
                      Change Training Designation
                    </Dropdown.Item>
                  </Link>

                  <Link to={`/user-management/employee/medical/` + id}>
                    <Dropdown.Item href="javascript:void(0)">
                      Change medical SME
                    </Dropdown.Item>
                  </Link>
                </>
              )}
            </>
          ) : (
            ""
          )}

          <Link to={`/user-management/employee/employment/` + id}>
            <Dropdown.Item href="javascript:void(0)">
              Edit employment status
            </Dropdown.Item>
          </Link>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

export default EmployeeId;
